import { render } from "./MultimediaTab.vue?vue&type=template&id=cd627ce4&scoped=true"
import script from "./MultimediaTab.vue?vue&type=script&lang=js"
export * from "./MultimediaTab.vue?vue&type=script&lang=js"

import "./MultimediaTab.vue?vue&type=style&index=0&id=cd627ce4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd627ce4"]])

export default __exports__